import { render } from "./DeleteOrderModalDialog.vue?vue&type=template&id=56f476ae&scoped=true&ts=true&lang=pug"
import script from "./DeleteOrderModalDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteOrderModalDialog.vue?vue&type=script&lang=ts"

import "./DeleteOrderModalDialog.vue?vue&type=style&index=0&id=56f476ae&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f476ae"]])

export default __exports__